module.exports = __webpack_public_path__ + "media/images/new_home/logo-white-5b922f499abd4597b4d20fe3dd70f972.png";